import { all, takeEvery, put, fork, call } from "redux-saga/effects";

import { storeService, selectStoreService } from "@iso/services";
import actions from "@iso/redux/store/actions";

function* getStoresDataRequest() {
  yield takeEvery(actions.GET_STORES_DATA_REQUEST, function* ({ payload }) {
    const { data } = payload;
    try {
      const stores = yield call(storeService.getStores, { data });
      yield put({
        type: actions.GET_STORES_DATA_SUCCESS,
        stores: stores ? stores.stores : [],
        total: stores ? stores.total : 0,
      });
    } catch (e) {
      yield put({
        type: actions.GET_STORES_DATA_ERROR,
        error: e.response,
      });
    }
  });
}

function* getStoresMetaDataRequest() {
  yield takeEvery(actions.GET_STORES_METADATA_REQUEST, function* () {
    try {
      const [directors, selectStores, adInCharges] = yield all([
        call(storeService.getDirectors),
        call(storeService.getSelectStores),
        call(storeService.getDirectorsAddEdit, { currentDirector: null }),
      ]);
      yield put({
        type: actions.GET_STORES_METADATA_SUCCESS,
        directors: directors ? directors.accounts : [],
        adInCharges: adInCharges ? adInCharges.accounts : [],
        selectStores: selectStores ? selectStores.stores : [],
      });
    } catch (e) {
      yield put({ type: actions.GET_STORES_METADATA_ERROR, error: e.response });
    }
  });
}

function* getStoreOTAs() {
  yield takeEvery(actions.GET_STORE_OTAS_REQUEST, function* ({ storeId }) {
    try {
      const otas = yield call(storeService.getStoreOTAs, { storeId });
      yield put({
        type: actions.GET_STORE_OTAS_SUCCESS,
        otas: otas ? otas : [],
      });
    } catch (error) {
      yield put({
        type: actions.GET_STORE_OTAS_ERROR,
        error: error.response,
      });
    }
  });
}

function* getStoreById() {
  yield takeEvery(actions.GET_STORE_BY_ID, function* ({ storeId }) {
    try {
      const store = yield call(storeService.getStoreById, { storeId });
      yield put({
        type: actions.GET_STORE_BY_ID_SUCCESS,
        store: store ? store : {},
      });
    } catch (error) {
      yield put({
        type: actions.GET_STORE_BY_ID_ERROR,
        error: error.response,
      });
    }
  });
}

function* getAccountInStore() {
  yield takeEvery(actions.GET_ACCOUNT_IN_STORE_REQUEST, function* ({ payload }) {
    try {
      const { storeId } = payload;
      const response = yield call(storeService.getAccountInStore, { storeId });
      yield put({
        type: actions.GET_ACCOUNT_IN_STORE_SUCCESS,
        accounts: response ? response : [],
      });
    } catch (error) {
      yield put({
        type: actions.GET_ACCOUNT_IN_STORE_ERROR,
        error: error.response,
      });
    }
  });
}


export default function* rootSaga() {
  yield all([
    fork(getStoresDataRequest),
    fork(getStoresMetaDataRequest),
    fork(getStoreOTAs),
    fork(getStoreById),
    fork(getAccountInStore),
  ]);
}
